<template>
  <div>
    <div
      class="container"
      :style="{
        opacity: screensaverOpacity,
        transform: `scale(${screensaverOpacity * 0.1 + 0.9})`,
        backgroundImage: 'url(/screensaver/snuggle.jpg)',
      }"
    ></div>
    <div
      class="flyer-bg"
      :style="{
        opacity: screensaverOpacity,
        backgroundImage: 'url(/screensaver/snuggle_blur.jpg)',
      }"
    />
  </div>
</template>
<script>
export default {
  props: ["screensaverOpacity"],
  data() {
    return {
      nextPartyDate: JSON.parse(process.env.VUE_APP_NEXT_PARTY_DATE),
      ticketSaleStart: JSON.parse(process.env.VUE_APP_TICKET_SALE_START),
    };
  },
};
</script>
<style scoped lang="scss">
div.container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  opacity: 0;
  font-size: 20px;
  width: 100vw;
  height: 100vh;
  background-color: transparent;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  transform: scale(0.9);
  transition: opacity 800ms ease-in-out, transform 1s ease-in-out 200ms;
}

div.flyer-bg {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-size: cover;
  transition: opacity 1s ease-in-out 500ms;
  z-index: -1;
  opacity: 0;
}
</style>
<i18n src="@/locales/global.json" />
